import { redirect, type ParsedLocation } from '@tanstack/react-router';
import { pastVideosTabHref } from './links';
import { parsePastVideoSearch } from './search';
import { parsePastVideosNarrow } from './tab-search';

/**
 * Past videos' old addresses, as routes' `beforeLoad` (Kazzy, 16 Oct 2026: past videos aren't reviewing, so they left
 * Review for Artifacts). Each lands as a replace, keeping what the old link carried that the new page reads.
 */

/** `/review/past-videos` and `/past-videos` → Artifacts' Past videos tab (narrowed as the link was). */
export function redirectToPastVideosTab({ location }: { location: Pick<ParsedLocation, 'search'> }): never {
  throw redirect({ href: pastVideosTabHref(parsePastVideosNarrow(location.search as Record<string, unknown>)), replace: true });
}

/** `/review/past-videos/<id>` → `/past-videos/<id>`, keeping the check, the comparison, the open video and the view. */
export function redirectToPastVideoGroup({ location, params }: { location: Pick<ParsedLocation, 'search'>; params: { setId: string } }): never {
  throw redirect({ to: '/past-videos/$setId', params: { setId: params.setId }, search: parsePastVideoSearch(location.search as Record<string, unknown>), replace: true });
}
